// @flow

export const PALETTE = "PALETTE";
export const UNKNOWN = "UNKNOWN";

export const SCALING_ALGORITHM = {
  AUTO: "AUTO",
  PIXELATED: "PIXELATED"
};
